/* Swiper init for the best sellers and venue carousels. */

(function () {
  'use strict';

  var CAROUSELS = [
    { root: '.best-sellers', swiper: '.best-sellers__swiper', prev: '.best-sellers__nav--prev', next: '.best-sellers__nav--next' },
    { root: '.venue-carousel', swiper: '.venue-carousel__swiper', prev: '.venue-carousel__nav--prev', next: '.venue-carousel__nav--next', pagination: '.venue-carousel__pagination' }
  ];

  var RETRY_MS = 150;
  var GIVE_UP_MS = 4000;

  // The skeleton is CSS driven and clears when Swiper adds .swiper-initialized,
  // so it has to be released by hand if Swiper never turns up.
  function release(scope) {
    (scope || document).querySelectorAll('.hp-carousel').forEach(function (el) {
      el.classList.add('hp-carousel--ready');
    });
  }

  function init(root, config) {
    if (root.dataset.carouselInitialised === 'true') return;

    var container = root.querySelector(config.swiper);
    if (!container || typeof window.Swiper === 'undefined') return;

    var perView = parseInt(container.dataset.perView, 10) || 4;

    var options = {
      slidesPerView: 1.2,
      spaceBetween: 12,
      watchOverflow: true,
      a11y: { enabled: true },
      navigation: {
        prevEl: root.querySelector(config.prev),
        nextEl: root.querySelector(config.next)
      },
      breakpoints: {
        750: { slidesPerView: 2.2, spaceBetween: 16 },
        990: { slidesPerView: perView, spaceBetween: 16 }
      }
    };

    if (config.pagination) {
      options.pagination = { el: root.querySelector(config.pagination), clickable: true };
    }

    new window.Swiper(container, options);
    root.dataset.carouselInitialised = 'true';
  }

  function initAll(scope, waitedFor) {
    var context = scope || document;

    if (typeof window.Swiper === 'undefined') {
      var waited = waitedFor || 0;
      if (waited >= GIVE_UP_MS) {
        release(context);
        return;
      }
      window.setTimeout(function () {
        initAll(scope, waited + RETRY_MS);
      }, RETRY_MS);
      return;
    }

    CAROUSELS.forEach(function (config) {
      context.querySelectorAll(config.root).forEach(function (root) {
        init(root, config);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
